(function (ws, global) {
    'use strict';
    /**
     * @typedef {Object} Event - DOM Event object
     */
    ws.views.savedCartContinueModal = ws.views.modal.extend({

        events: _.extend({}, ws.views.modal.prototype.events, {
            'click .csc-continue-confirm-popup-btn': 'makeActiveCart'
        }),

        /**
         * Initialize
         */
        initialize: function () {
            ws.views.modal.prototype.initialize.call(this);
            this.$makeActiveForm = $('.csc-make-active-form');
        },

        /**
         * Make current cart active
         */
        makeActiveCart: function() {
            _satellite.track('event:ContinueSavedCart');
            this.$makeActiveForm.submit();
        }
    });
})(westcon, window);
